
export const sizeAdjust = (factor: any) => {
    
    const drawerFactor = factor < 1 ? factor / 0.75 : 1 + (factor - 1) * 0.75;
    
    const sizeStyles = {
        initialDrawerWidth: 300 * drawerFactor,
        paddingWidth: 20 * factor,
        drawerPadding: 30* drawerFactor,

    }

    return sizeStyles
}